<template>
    <window-portal :open="dataProps.show" @close="() => {
        dataProps.show = false
        if(dataProps?.closeCallback){
            dataProps?.closeCallback()
        };
    }
        ">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista Previa Reporte de Corte de Caja</p></div></center>
            <br/>
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>
        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>
        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="margin: 0 auto; width: 1000px;">
                    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                        <div v-for="(page, indexPage) in pages" :key="indexPage" style="position: relative; width: 1000px; min-height: 1293px; background: white;">
                            <hr/>
                            <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                                <div style="margin-left: 80px; margin-right: 50px;">
                                    <div style="text-transform: uppercase;">
                                        <b>
                                            {{ businessName }} - {{ branchName }}
                                        </b>
                                    </div>
                                    <div>
                                        <div style="text-align: center; float: left; font-size: 15px;">
                                            REPORTE DE CORTE DE CAJA
                                        </div>
                                        <div style="text-align: center; float: right; font-size: 15px;">
                                            DEL "{{ formatDateToDDMMYYYYStart }}" AL "{{ formatDateToDDMMYYYYEnd }}"
                                        </div>
                                    </div>
                                    <br>
                                    
                                    <div v-if="hasTypeItem('CONTADO', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        INGRESOS POR VENTA AL CONTADO
                                    </div>
                                    <table v-if="hasTypeItem('CONTADO', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; width: 230px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">VENTA</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('CONTADO', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.Total }}</td>
                                        </tr>
                                    </table>

                                    <div v-if="hasTypeItem('INGRESOS', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        INGRESOS
                                    </div>
                                    <table v-if="hasTypeItem('INGRESOS', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">DETALLE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">VENTA</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('INGRESOS', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceStatusDescription }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.Total }}</td>
                                        </tr>
                                    </table>

                                    <div v-if="hasTypeItem('ANTICIPO', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        ANTICIPO
                                        {{ item }}
                                    </div>
                                    <table v-if="hasTypeItem('ANTICIPO', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">DETALLE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">VENTA</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('ANTICIPO', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceStatusDescription }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.Total }}</td>
                                        </tr>
                                    </table>

                                    <div v-if="hasTypeItem('CREDITO', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        CRÉDITO
                                    </div>
                                    <table v-if="hasTypeItem('CREDITO', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <!-- <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">DETALLE</td> -->
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">VENTA</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('CREDITO', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <!-- <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td> -->
                                            <td style="padding: 5px;">{{ item.InvoiceStatusDescription }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.Total }}</td>
                                        </tr>
                                    </table>
                                    <!-- <div v-if="hasTypeItem('EGRESOS', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        EGRESOS
                                    </div>
                                    <table v-if="hasTypeItem('EGRESOS', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">DETALLE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">VENTA</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('EGRESOS', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceStatusDescription }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.Total }}</td>
                                        </tr>
                                    </table> -->
                                    <div v-if="hasTypeItem('EGRESOS', indexPage)" style="text-align: left; font-size: 14px; margin-top: 20px;">
                                        EGRESOS
                                    </div>
                                    <table v-if="hasTypeItem('EGRESOS', indexPage)" style="font-size: 10px; border-collapse: collapse; width: 100%; margin-top: 10px;">
                                        <tr>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">FECHA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">ID FACTURA</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CLIENTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">CÓDIGO GENERACIÓN</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">TIPO DE PAGO</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">DETALLE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px;">COMPROBANTE</td>
                                            <td style="border-top: 1px solid; border-bottom: 1px solid; padding: 5px; text-align: right;">DEVOLUCIÓN</td>
                                        </tr>
                                        <tr v-for="(item, index) in filterByCategory('EGRESOS', valuesRows[indexPage])" :key="index">
                                            <td style="padding: 5px;">{{ item.InvoiceDate }}</td>
                                            <td style="padding: 5px;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceName }}</td>
                                            <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                            <td style="padding: 5px;">{{ getPaymentTypeDesc(item) }}</td>
                                            <td style="padding: 5px;">{{ item.InvoiceStatusDescription }}</td>
                                            <td style="padding: 5px;">{{ item.Total }}</td>
                                            <td style="padding: 5px; text-align: right;">{{ item.sum === 1 && item.abonado === '$0.00' ? item.Total : item.abonado  }}</td>
                                        </tr>
                                    </table>

                                    <div v-if="indexPage == (numPages - 1)" style="float: left; margin-top: 20px;">
                                        <table style="font-size: 13px;">

                                            <tr>
                                                <td>
                                                    <strong>ANTICIPO</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Billetes y monedas
                                                </td>
                                                <td style="text-align: right;">${{ totalBillsAndCoinsAnticipo }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Tarjetas de credito/debito
                                                </td>
                                                <td style="text-align: right;">${{ totalCardsAnticipo }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Transferencias bancarias
                                                </td>
                                                <td style="text-align: right;">${{ totalTransferAnticipo }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Cheques
                                                </td>
                                                <td style="text-align: right;">${{ totalCheckAnticipo }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <strong>Total anticipo</strong>
                                                </td>
                                                <td style="text-align: right;">
                                                    <strong style="border-top: 1px solid black;">${{ totalAnticipos }}</strong>
                                                </td>
                                            </tr>

                                            <br>

                                            <tr>
                                                <td>
                                                    <strong>ABONOS (facturas)</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Billetes y monedas
                                                </td>
                                                <td style="text-align: right;">${{ totalBillsAndCoinsAbonos }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Tarjetas de credito/debito
                                                </td>
                                                <td style="text-align: right;">${{ totalCardsAbonos }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Transferencias bancarias
                                                </td>
                                                <td style="text-align: right;">${{ totalTransferAbonos }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Cheques
                                                </td>
                                                <td style="text-align: right;">${{ totalCheckAbonos }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <strong>Total abonos</strong>
                                                </td>
                                                <td style="text-align: right;">
                                                    <strong style="border-top: 1px solid black;">${{ totalAbonoGeneral }}</strong>
                                                </td>
                                            </tr>
                                            
                                        </table>
                                    </div>

                                    <div v-if="indexPage == (numPages - 1)" style="float: right; margin-top: 20px;">
                                        <table style="font-size: 13px;">
                                            <tr>
                                                <td>
                                                    (+)
                                                </td>
                                                <td style="padding-right: 20px;" colspan="2"> Ingresos por venta contado</td>
                                                <td style="text-align: right;">${{ totalBillsAndCoinsGeneral }}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    
                                                </td>
                                                <td style="padding-right: 20px;"> Billetes y monedas</td>
                                                <td>

                                                </td>
                                                <td style="text-align: right;">${{ totalBillsAndCoinsGeneral }}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>
                                                    (+)
                                                </td>
                                                <td style="padding-right: 20px;" colspan="2">Total por tarjetas de crédito/débito</td>
                                                <td style="text-align: right;" colspan="2">${{ totalCardsGeneral }}</td>
                                            </tr>
                                            <tr>
                                                <td>

                                                </td>
                                                <td style="padding-right: 20px;">Total de crédito</td>
                                                <td>

                                                </td>
                                                <td style="text-align: right;">${{ totalCreditCard }}</td>
                                            </tr>
                                            <tr>
                                                <td>

                                                </td>
                                                <td style="padding-right: 20px;">Total de débito</td>
                                                <td>

                                                </td>
                                                <td style="text-align: right;">${{ totalDebitCard }}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>
                                                    (+)
                                                </td>
                                                <td style="padding-right: 20px;" colspan="2">Transferencias Bancarias</td>
                                                <td style="text-align: right;" colspan="2">${{ totalTransferGeneral }}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>
                                                    (+)
                                                </td>
                                                <td style="padding-right: 20px;" colspan="2">Cheques</td>
                                                <td style="text-align: right;" colspan="2">${{ totalCheckGeneral }}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>
                                                    (+)
                                                </td>
                                                <td style="padding-right: 20px;" colspan="2">Otros</td>
                                                <td style="text-align: right;" colspan="2">${{ totalOthersGeneral }}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>(=)</td>
                                                <td style="padding-right: 20px;" colspan="2">Sub. Total</td>
                                                <td style="text-align: right;" colspan="2">${{ subTotal }}</td>
                                            </tr>
                                            <br/>
                                            <tr>
                                                <td>(-)</td>
                                                <td style="padding-right: 20px;" colspan="2">Egresos</td>
                                                <td style="text-align: right;" colspan="2">${{ totalEgresos }}</td>
                                            </tr>
                                            <br/>
                                            <tr>
                                                <td>(+)</td>
                                                <td style="padding-right: 20px;" colspan="2">Total al crédito</td>
                                                <td style="text-align: right;" colspan="2">${{ totalCredito }}</td>
                                            </tr>
                                            <tr>
                                                <td>(=)</td>
                                                <td style="padding-right: 20px;" colspan="2">Total</td>
                                                <td style="text-align: right;" colspan="2">${{ total }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    
                                </div>
                                
                                <div style="position: absolute; bottom: 0; width: 100%; left: 80px">
                                    <p style="font-size:10px;">Pagina {{ indexPage+1 }} de {{ numPages }}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"

export default {
    name: "PrintCashierCutDetails",
    props: {
        dataProps: {
            type: Object,
        },
        hideQr: {
            type: Boolean,
            default: false
        }
    },
    components: {WindowPortal},
    data() {
        return {
            loading: false,
            numPages: 0,
            valuesRows: [],
            subTotal: 0,
            totalIngresos: 0,
            totalCredito: 0,
            totalEgresos: 0,
            total: 0,
            totalInvalidado: 0,
            totalContadoGeneral: 0,
            totalInvalidadoGeneral: 0,
            totalCreditoGeneral: 0,
            totalAbonoGeneral: 0,
            totalBillsAndCoins: 0,
            totalCards: 0,
            totalCheck: 0,
            totalTransfer: 0,
            totalOthers: 0,
            totalBillsAndCoinsGeneral: 0,
            totalCardsGeneral: 0,
            totalCheckGeneral: 0,
            totalTransferGeneral: 0,
            totalOthersGeneral: 0,
            totalDebitCard: 0,
            totalCreditCard: 0,

            totalBillsAndCoinsAnticipo: 0,
            totalCardsAnticipo: 0,
            totalTransferAnticipo: 0,
            totalCheckAnticipo: 0,
            totalAnticipos: 0,
            totalBillsAndCoinsAbonos: 0,
            totalCardsAbonos: 0,
            totalTransferAbonos: 0,
            totalCheckAbonos: 0,
            totalAbonos: 0,
            branchName: JSON.parse(localStorage.getItem('branch'))?.BranchName || '',
            businessName: JSON.parse(localStorage.getItem('user'))?.business || '',
        }
    },
    mounted() {
    },
    computed: {
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
        formatDateToDDMMYYYYStart() {
            const dateStr = this.dataProps.data.dates.start;

            if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
                return dateStr;
            }

            // Si la fecha está en formato YYYY-MM-DD
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts.map(Number);
                const d = new Date(year, month - 1, day);
                if (isNaN(d.getTime())) {
                    return 'Fecha inválida'; 
                }   
                const dayStr = d.getDate().toString().padStart(2, '0');
                const monthStr = (d.getMonth() + 1).toString().padStart(2, '0');
                return `${dayStr}/${monthStr}/${year}`;
            }

            return this.dataProps.data.dates.start;
        },
        formatDateToDDMMYYYYEnd() {
            const dateStr = this.dataProps.data.dates.end;

            if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
                return dateStr;
            }

            // Si la fecha está en formato YYYY-MM-DD
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts.map(Number);
                const d = new Date(year, month - 1, day);
                if (isNaN(d.getTime())) {
                    return 'Fecha inválida'; 
                }   
                const dayStr = d.getDate().toString().padStart(2, '0');
                const monthStr = (d.getMonth() + 1).toString().padStart(2, '0');
                return `${dayStr}/${monthStr}/${year}`;
            }

            return this.dataProps.data.dates.end;
        },
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show){
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        }
    },
    methods: {
        calculateTotalsCashierCut(body) {
            try {
                
                this.totalContadoGeneral = 0;
                this.totalAbonoGeneral = 0;
                this.totalInvalidadoGeneral = 0;
                this.totalCreditoGeneral = 0;
                this.totalBillsAndCoinsGeneral = 0
                this.totalCardsGeneral = 0
                this.totalCheckGeneral = 0
                this.totalTransferGeneral = 0
                this.totalOthersGeneral = 0
                this.totalCreditCard = 0;
                this.totalDebitCard = 0;

                this.totalBillsAndCoinsAnticipo = 0;
                this.totalCardsAnticipo = 0;
                this.totalTransferAnticipo = 0;
                this.totalCheckAnticipo = 0;
                this.totalAnticipos = 0;
                this.totalBillsAndCoinsAbonos = 0;
                this.totalCardsAbonos = 0;
                this.totalTransferAbonos = 0;
                this.totalCheckAbonos = 0;

                const billsAndCoinsAnticipoType = [
                    '01',
                ];
                const cardsType = [
                    '02',
                    '03',
                ];
                const transfersType = [
                    '05',
                ];
    
                body.forEach((item) => {
                    if (item.InvoiceStatusDescription == "ANTICIPO" && billsAndCoinsAnticipoType.includes(item.Codigo)) {
                        this.totalBillsAndCoinsAnticipo += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ANTICIPO" && cardsType.includes(item.Codigo)) {
                        this.totalCardsAnticipo += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ANTICIPO" && transfersType.includes(item.Codigo)) {
                        this.totalTransferAnticipo += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ANTICIPO" && item.Codigo == "04") {
                        this.totalCheckAnticipo += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }

                    if (item.InvoiceStatusDescription == "ABONO" && billsAndCoinsAnticipoType.includes(item.Codigo)) {
                        this.totalBillsAndCoinsAbonos += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ABONO" && cardsType.includes(item.Codigo)) {
                        this.totalCardsAbonos += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ABONO" && transfersType.includes(item.Codigo)) {
                        this.totalTransferAbonos += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    if (item.InvoiceStatusDescription == "ABONO" && item.Codigo == "04") {
                        this.totalCheckAbonos += parseFloat(item.Total.replace(/[$,]/g, ""));
                    }
                    
                    if (item.InvoiceStatusDescription == "Cancelada") {
                    this.totalContadoGeneral += parseFloat(
                        item.Total.replace(/[$,]/g, "")
                    );
                    } else if (item.InvoiceStatusDescription == "ABONO") {
                    this.totalAbonoGeneral += parseFloat(item.Total.replace(/[$,]/g, ""));
                    } else if (item.InvoiceStatusDescription == "ANTICIPO") {
                        this.totalAnticipos += parseFloat(item.Total.replace(/[$,]/g, ""));
                    } else if (item.InvoiceStatusDescription == "Crédito") {
                    this.totalCreditoGeneral += parseFloat(
                        item.Total.replace(/[$,]/g, "")
                    );
                    } else if (
                    item.InvoiceStatusDescription == "INVALIDADO" ||
                    item.InvoiceStatusDescription == "NOTA DE CREDITO" ||
                    item.InvoiceStatusDescription == "NOTA DE DEBITO"
                    ) {
                    this.totalInvalidadoGeneral += parseFloat(
                        item.Total.replace(/[$,]/g, "")
                    );
                    }
    
                    if (item.Codigo == "01") {
                        this.totalBillsAndCoinsGeneral += parseFloat(item.TotalSale);
                    } else if (["02", "03"].includes(item.Codigo)) {
                        if( item.Codigo === "02" ) {
                            this.totalDebitCard += parseFloat( item.TotalSale );
                        } 
                        if( item.Codigo === "03" ) {
                            this.totalCreditCard += parseFloat( item.TotalSale );
                        }
                        this.totalCardsGeneral += parseFloat(item.TotalSale);
                    } else if (item.Codigo == "04") {
                        this.totalCheckGeneral += parseFloat(item.TotalSale);
                    } else if (item.Codigo == "05") {
                        this.totalTransferGeneral += parseFloat(item.TotalSale);
                    } else {
                        if(item.InvoiceStatusDescription != "ANTICIPO" && item.InvoiceStatusDescription != "ABONO" 
                            && item.InvoiceStatusDescription != "Crédito"
                            && item.InvoiceStatusDescription != "NOTA DE CREDITO"
                            && item.InvoiceStatusDescription != "INVALIDADO"
                        ) {
                            this.totalOthersGeneral += parseFloat(item.TotalSale);
                        }
                    }
                });

                this.subTotal = parseFloat( this.totalTransferGeneral + this.totalCardsGeneral + this.totalBillsAndCoinsGeneral + this.totalCheckGeneral ).toFixed( 2 );
                this.totalCreditCard = parseFloat( this.totalCreditCard ).toFixed(2)
                this.totalDebitCard = parseFloat( this.totalDebitCard ).toFixed(2)
                this.totalContadoGeneral = parseFloat(this.totalContadoGeneral).toFixed(2);
                this.totalBillsAndCoinsAnticipo = parseFloat(this.totalBillsAndCoinsAnticipo).toFixed(2);
                this.totalCardsAnticipo = parseFloat(this.totalCardsAnticipo).toFixed(2);
                this.totalTransferAnticipo = parseFloat(this.totalTransferAnticipo).toFixed(2);
                this.totalCheckAnticipo = parseFloat(this.totalCheckAnticipo).toFixed(2);
                this.totalAnticipos = parseFloat(this.totalAnticipos).toFixed(2);
                this.totalAbonoGeneral = parseFloat(this.totalAbonoGeneral).toFixed(2);
                this.totalInvalidadoGeneral = parseFloat(this.totalInvalidadoGeneral).toFixed(2);
                this.totalCreditoGeneral = parseFloat(this.totalCreditoGeneral).toFixed(2);
                this.totalBillsAndCoinsGeneral = parseFloat(this.totalBillsAndCoinsGeneral).toFixed(2); 
                this.totalCardsGeneral = parseFloat(this.totalCardsGeneral).toFixed(2);
                this.totalCheckGeneral = parseFloat(this.totalCheckGeneral).toFixed(2);
                this.totalTransferGeneral = parseFloat(this.totalTransferGeneral).toFixed(2);
                this.totalOthersGeneral = parseFloat(this.totalOthersGeneral).toFixed(2);
            } catch (error) {
                console.log( 'calculateTotalsCashierCut ', error.message );
            }
        },
        hasTypeItem(type, indexPage) {
            // Verificar si existe una página en el índice dado y si contiene la categoría deseada
            return this.valuesRows[indexPage] && this.valuesRows[indexPage].some(item => 
                item.Categoria === type
            );
        },
        filterByCategory(type, items) {
            return items.filter(item => item.Categoria === type);
        },
        calculatePagesOfDoc() {
            let pages = 0
            let rows = 0
            const maxRowsPerPage = 48
            this.valuesRows[pages] = []
            this.subTotal = 0
            this.totalIngresos = 0
            this.totalCredito = 0
            this.totalEgresos = 0
            this.total = 0

            try{
                const body = this.dataProps.data.body

                const salesPrefixes = ["FCF", "CCF", "FEX", "TCKS"]
                const creditPrefixes = [...salesPrefixes, "RCIB"]

                const categories = {
                    "CONTADO": [],
                    "INGRESOS": [],
                    "EGRESOS": [],
                    "INVALIDACIONES": [],
                    "CREDITO": [],
                    "ANTICIPO": [],
                }

                body.forEach(item => {
                    const invoiceId = String(item.ID_Invoice || "")
                    const isSalesDocument = salesPrefixes.some(prefix => invoiceId.includes(prefix))
                    const isCreditDocument = creditPrefixes.some(prefix => invoiceId.includes(prefix))

                    if (isSalesDocument
                        && item.InvoiceStatusDescription == "Cancelada") {
                            categories["CONTADO"].push(item)
                    } else if (isCreditDocument 
                        && item.InvoiceStatusDescription != "Cancelada" && item.InvoiceStatusDescription != "INVALIDADO" && item.InvoiceStatusDescription != 'Crédito' &&
                        item.InvoiceStatusDescription != 'ANTICIPO') {
                            this.totalIngresos += parseFloat(item.Total.replace(/[$,]/g, ''))
                            categories["INGRESOS"].push(item)
                    } else if (isCreditDocument 
                        && item.InvoiceStatusDescription == 'Crédito') {
                            this.totalCredito += parseFloat(item.Total.replace(/[$,]/g, ''))
                            categories["CREDITO"].push(item)
                    } else if ((item.ID_Invoice.includes("FNS") || item.ID_Invoice.includes("DNC") || item.ID_Invoice.includes("DND") || item.InvoiceStatusDescription.includes("INVALIDADO"))) {
                        // if (!item.InvoiceStatusDescription.includes("INVALIDADO")) {
                        //     this.totalEgresos += Math.abs(parseFloat(item.Total.replace(/[$,]/g, '')))
                        // } else {
                            this.totalEgresos += Math.abs(parseFloat(((item.sum === 1 && item.abonado === '$0.00' ? item.Total : `${item.abonado}`) ?? 0).replace(/[$,]/g, '')))
                        // }
                        categories["EGRESOS"].push(item)
                    } else if (item.InvoiceStatusDescription == 'ANTICIPO') {
                            this.totalIngresos += parseFloat(item.Total.replace(/[$,]/g, ''))
                            categories["ANTICIPO"].push(item)
                    }
                    // if( item.InvoiceStatusDescription == "INVALIDADO" ) {
                    //     categories["INVALIDACIONES"].push(item)
                    // }
                })

                const processCategory = (group, type) => {
                    for (const item of group) {
                        if (!this.valuesRows[pages].some(element => element.Categoria === type)) {
                            rows = rows + 3;
                        }

                        if (rows >= maxRowsPerPage) {
                            pages++;
                            rows = 0;
                            this.valuesRows[pages] = [];
                        }
                        // Añadir el registro al arreglo de la página actual
                        item.Categoria = type

                        // console.log('pages', pages + 1);
                        // console.log('rows', rows);
                        // console.log('type', type, item.Total);
                        this.valuesRows[pages].push(item);
                        // console.log('item', item);

                        // En estas condicionales se intenta contabilizar el número de filas que puede ocupar el item
                        if ((item.InvoiceName.length > 37 &&
                                item.CodigoGeneracion != ''
                            ) &&
                            item.Categoria !== 'CREDITO'
                        ) {
                            rows = rows + 2;
                        } else {
                            rows++;
                        }
                        // console.log('rows', rows);
                    }
                }

                processCategory(categories["CONTADO"], "CONTADO");
                processCategory(categories["INGRESOS"], "INGRESOS");
                processCategory(categories["ANTICIPO"], "ANTICIPO");
                processCategory(categories["CREDITO"], "CREDITO");
                processCategory(categories["EGRESOS"], "EGRESOS");
                // processCategory(categories["INVALIDACIONES"], "INVALIDACIONES");

                // console.log('pages', pages + 1);
                // console.log('rows', rows);
                if( rows > 20 ) {
                    pages++;
                    this.valuesRows.push( [] );
                }

                this.calculateTotalsCashierCut( body );

                this.totalCredito = parseFloat(this.totalCredito).toFixed(2)
                this.total = parseFloat(parseFloat( this.subTotal ) + parseFloat(this.totalOthersGeneral) + parseFloat(this.totalCredito) - this.totalEgresos).toFixed(2)
                this.subTotal = parseFloat(this.subTotal).toFixed(2)
                this.totalIngresos = parseFloat(this.totalIngresos).toFixed(2)
                this.totalEgresos = parseFloat(this.totalEgresos).toFixed(2)
            }
            catch(err) {
                alert(err)
            }
            pages = pages + 1
            this.numPages = pages
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
            doc.save("CorteDeCajaDiario.pdf"); 

            this.loading = false
        },

        getPaymentTypeDesc(item) {
            const DescPaymentType = item.InvoiceStatusDescription.toLowerCase() === 'invalidado' 
                ? 'INVALIDADO'
                : item.DescPaymentType;

            return DescPaymentType;
        },
    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
  background-color: #F29D35 !important;
  color: white !important;
}
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

 

</style>
